import { render, staticRenderFns } from "./downloadFile.vue?vue&type=template&id=b40e93ae&scoped=true"
import script from "./downloadFile.vue?vue&type=script&lang=js"
export * from "./downloadFile.vue?vue&type=script&lang=js"
import style0 from "./downloadFile.vue?vue&type=style&index=0&id=b40e93ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e93ae",
  null
  
)

export default component.exports